export class UrlUtils {
  static getSplitPathname(url: string) {
    url = decodeURIComponent(url);
    let urlSplit = url.split('?')[0];
    urlSplit = urlSplit.split('#')[0];

    return urlSplit.split('/');
  }
}
